module.exports = __webpack_public_path__ + "static/media/mau.520f3f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/mau.png
// module id = 1150
// module chunks = 0